import { omitBy, isNil } from 'lodash'

export function omitNullOrUndefinedValues(obj: object): any {
    return omitBy(obj, isNil)
}
